import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, Switch } from 'react-toolbox';
import cx from 'classnames';
import PhoneInput from 'components/PhoneType/PhoneInput';
import TimeInput from 'components/TimeInput';
import FlexBox from 'flexbox-react';
import styles from 'styles/form';
import common from 'styles/common.scss';
import { nestedError, generateSource } from '../../../../../utils';
import ColoredButton from 'components/ColoredButton';
import { PHONE_TYPES_W_FAX } from 'config/constants';
import PhoneType from 'components/PhoneType';
import ReactSelect from 'components/StyledSelect/react_select';
import StyledSelect from 'components/StyledSelect';
// import RadioButtons from 'components/RadioButtons';
import crewStyle from './crewForm.scss';
import reactSelectStyles from 'components/ReactSelect/styles';
import DatePicker from 'components/DatePicker';
import SurfaceTypesCheckbox from 'components/formElements/SurfaceTypesCheckbox';
import CustomTaggedInput from 'components/TaggedInput/CustomTaggedInput/CTIIndex';
import ConflictingAppointmentModal from 'conflictingAppointmentModal';

const removeButton = cx(
  styles.cancelButton,
  styles.actionButton,
  common.floatRight,
  crewStyle.removeButtonFloatFix,
);

class CrewForm extends Component {
  constructor(props) {
    super(props);
    const { onChange, onSpecificChange, onDelete, index } = this.props;
    this.handleDelete = () => onDelete(index);
    this.showError = nestedError.bind(this, 'crews', index);
    this.onNameChange = onChange.bind(this, 'name');
    this.onPriorityChange = onChange.bind(this, 'priority');
    this.onActiveChange = onChange.bind(this, 'active');
    this.onUseInstallerPayChange = onChange.bind(this, 'use_installer_pay');
    this.onPOCNameChange = onChange.bind(this, 'poc_name');
    this.onPhoneNumberChange = onChange.bind(this, 'phone_number');
    this.onPhoneNumberTypeChange = onChange.bind(this, 'phone_number_type');
    this.onEmailChange = onChange.bind(this, 'email');
    this.onBadgeNumberChange = onChange.bind(this, 'badge_number');
    this.onBadgeExpirationChange = onChange.bind(this, 'badge_expiration');
    this.onBadgeLinkChange = onChange.bind(this, 'badge_link');
    this.onWorkroomsChange = onChange.bind(this, 'workrooms');
    this.onDefaultStartTimeChange = onChange.bind(this, 'default_start_time');
    this.onCommentsChange = onChange.bind(this, 'comments');
    this.onDeliveryChange = onChange.bind(this, 'can_deliver');
    this.onDeliveryDedicatedChange = onChange.bind(this, 'delivery_dedicated');
    this.onLoginableChange = onChange.bind(this, 'loginable');
    this.handleMaxTravelTime = onSpecificChange.bind(this, 'max_travel_time');
    this.handlePhoneCallNeeded = onSpecificChange.bind(this, 'phone_call_needed');
    this.handleHardwoodSfPerDay = onSpecificChange.bind(this, 'hardwood_sf_per_day');
    this.handleCarpetSfPerDay = onSpecificChange.bind(this, 'carpet_sf_per_day');
    this.handleTileSfPerDay = onSpecificChange.bind(this, 'tile_sf_per_day');
    this.handleLaminateSfPerDay = onSpecificChange.bind(this, 'laminate_sf_per_day');
    this.handleVinylSfPerDay = onSpecificChange.bind(this, 'vinyl_sf_per_day');
    this.handleVinylPlankSfPerDay = onSpecificChange.bind(this, 'vinyl_plank_sf_per_day');
    // this.handleMillworkWindowPerDay = onSpecificChange.bind(this, 'millwork_window_per_day');
    // this.handleMillworkEntryDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_entry_door_per_day');
    // this.handleMillworkSlidingDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_sliding_door_per_day');
    // this.handleMillworkInteriorDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_interior_door_per_day');
    this.handleBacksplashSfPerDay = onSpecificChange.bind(this, 'backsplash_sf_per_day');
    this.handleCanSpeakEnglish = onSpecificChange.bind(this, 'can_speak_english');
    this.handleCanSpeakSpanish = onSpecificChange.bind(this, 'can_speak_spanish');
    this.handleCanMoveFurniture = onSpecificChange.bind(this, 'can_move_furniture');
    this.handleCanMoveFurnitureOversized = onSpecificChange.bind(this, 'can_move_furniture_oversized');
    this.handleCanMoveAppliances = onSpecificChange.bind(this, 'can_move_appliances');
    this.handleCanDoSubfloorPrep = onSpecificChange.bind(this, 'can_do_subfloor_prep');
    this.handleCanDoSubfloorReplacement = onSpecificChange.bind(this, 'can_do_subfloor_replacement');
    this.handleSameDayMultiSurface = onSpecificChange.bind(this, 'same_day_multi_surface');
    this.handleCanDoNaildownHardwood = onSpecificChange.bind(this, 'can_do_naildown_hardwood');
    this.handleCanDoGluedownHardwood = onSpecificChange.bind(this, 'can_do_gluedown_hardwood');
    this.handleCanDoFloatingHardwood = onSpecificChange.bind(this, 'can_do_floating_hardwood');
    this.handleCanDoCaliBambooHardwood = onSpecificChange.bind(this, 'can_do_cali_bamboo_hardwood');
    this.handleCanDoStepsHardwood = onSpecificChange.bind(this, 'can_do_steps_hardwood');
    this.handleCanDoStretchInCarpet = onSpecificChange.bind(this, 'can_do_stretch_in_carpet');
    this.handleCanDoGluedownCarpet = onSpecificChange.bind(this, 'can_do_gluedown_carpet');
    this.handleCanDoBindingCarpet = onSpecificChange.bind(this, 'can_do_binding_carpet');
    this.handleCanDoPatternMatchCarpet = onSpecificChange.bind(this, 'can_do_pattern_match_carpet');
    this.handleCanDoBerberCarpet = onSpecificChange.bind(this, 'can_do_berber_carpet');
    this.handleCanDoStepsCarpet = onSpecificChange.bind(this, 'can_do_steps_carpet');
    this.handleCanDoFloorTile = onSpecificChange.bind(this, 'can_do_floor_tile');
    this.handleCanDoBacksplashTile = onSpecificChange.bind(this, 'can_do_backsplash_tile');
    this.handleCanDoBacksplashGlass = onSpecificChange.bind(this, 'can_do_backsplash_glass');
    this.handleCanDoBacksplashBlocking = onSpecificChange.bind(this, 'can_do_backsplash_blocking');
    this.handleCanDoPatternsTile = onSpecificChange.bind(this, 'can_do_patterns_tile');
    this.handleCanDoLargeFormatTile = onSpecificChange.bind(this, 'can_do_large_format_tile');
    this.handleCanDoVinylSheet = onSpecificChange.bind(this, 'can_do_vinyl_sheet');
    this.handleCanDoVinylTile = onSpecificChange.bind(this, 'can_do_vct_lvt');
    this.handleCanDoGluedownVinylPlank = onSpecificChange.bind(this, 'can_do_gluedown_vinyl_plank');
    this.handleCanDoFloatingVinylPlank = onSpecificChange.bind(this, 'can_do_floating_vinyl_plank');
    this.handleCanRemoveReplaceToilet = onSpecificChange.bind(this, 'can_remove_replace_toilet');
    this.handleCanRemoveNaildownHardwood = onSpecificChange.bind(this, 'can_remove_naildown_hardwood');
    this.handleCanRemoveFloatingHardwood = onSpecificChange.bind(this, 'can_remove_floating_hardwood');
    this.handleCanRemoveGluedownHardwood = onSpecificChange.bind(this, 'can_remove_gluedown_hardwood');
    this.handleCanRemoveOverPadCarpet = onSpecificChange.bind(this, 'can_remove_over_pad_carpet');
    this.handleCanRemoveGluedownCarpet = onSpecificChange.bind(this, 'can_remove_gluedown_carpet');
    this.handleCanRemoveLaminate = onSpecificChange.bind(this, 'can_remove_laminate');
    this.handleCanRemoveTile = onSpecificChange.bind(this, 'can_remove_tile');
    this.handleCanRemoveGluedownVinyl = onSpecificChange.bind(this, 'can_remove_gluedown_vinyl');
    this.handleCanRemoveVinylPlank = onSpecificChange.bind(this, 'can_remove_vinyl_plank');
    this.handleCanRemoveBacksplash = onSpecificChange.bind(this, 'can_remove_backsplash');
    this.handleCoveredZipCodes = onChange.bind(this, 'covered_zip_codes');
    this.handleCanInstallBaseBoard = onSpecificChange.bind(this, 'can_do_baseboard');
    this.handleCanInstallHardsurfaceTransitions = onSpecificChange.bind(this, 'can_install_hard_transitions');
    this.state = { showApptWarningDialog: false };
  }

  getAvailabilityVal = (day) => {
    const { install_availability = [], delivery_availability = [] } = this.props.crew;
    if (install_availability.includes(day)) return `${day}_install`;
    if (delivery_availability.includes(day)) return `${day}_delivery`;
    return `${day}_off`;
  }

  dailyOptions = () => {
    // eslint-disable-next-line no-unused-vars
    const { install_availability = [], delivery_availability = [] } = this.props.crew;
    return [
      { value: 1, label: 'Sunday' },
      { value: 2, label: 'Monday' },
      { value: 3, label: 'Tuesday' },
      { value: 4, label: 'Wednesday' },
      { value: 5, label: 'Thursday' },
      { value: 6, label: 'Friday' },
      { value: 7, label: 'Saturday' },
    ];
    // not filter based on unused appt availability for now
    // .filter(o => install_availability.concat(delivery_availability).includes(o.value));
  }

  handleApptWarningModal = display => this.setState({ showApptWarningDialog: display });

  render = () => {
    const { errors, crew, onSurfaceTypesChange, allWorkrooms, canRemoveCrew,
            canEdit, canEditBasic, workroomChange, onDailyChange, onChange,
            // eslint-disable-next-line no-unused-vars
            onAvailabilityChange, crewFieldWarnings, fieldError } = this.props;
    const { showApptWarningDialog } = this.state;
    const largeInput = cx(styles.childInputs, styles.largeInput);
    const mediumInput = cx(styles.childInputs, styles.mediumInput, styles.smallPadding);
    const workroomOptions = generateSource(allWorkrooms);
    const shouldShowRemoveButton = (crew.id === null || crew.id === undefined) &&
      canEdit && canRemoveCrew;
    const crewContainerStyles = cx([crewStyle.crewContainer, styles.childCard]);
    const crewSpecific = crew.crew_specific || {};
    const canEditSpecifics = canEdit || canEditBasic;
    const dailyAvailability = crew.daily_availability ? crew.daily_availability :
      { morning: [2, 3, 4, 5, 6], afternoon: [2, 3, 4, 5, 6] };
    return (<div className={crewContainerStyles}>
      <div className={crewStyle.mobileHeaderContainer}>
        <FlexBox>
          <Input
            label="Crew Name"
            value={crew.name}
            className={mediumInput}
            error={fieldError('name', crewFieldWarnings)}
            required
            onChange={this.onNameChange}
            disabled={!canEdit}
          />
          <StyledSelect
            name="priority"
            label="Delivery Priority"
            required
            className={mediumInput}
            options={[
              { value: 1, label: 1 },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 4, label: 4 },
              { value: 5, label: 5 },
            ]}
            value={crew.priority || 5}
            onChange={this.onPriorityChange}
            placeholder="Assign priority to crew"
            disabled={!canEdit}
            error={this.showError('priority', errors)}
          />
        </FlexBox>
        <FlexBox>
          <div className={crewStyle.switchStyling}>
            <Switch
              name="active"
              label="Crew Active"
              onChange={((crew || {}).appointments || []).length ?
                () => this.handleApptWarningModal(true) : this.onActiveChange}
              theme={crewStyle}
              checked={crew.active || false}
              disabled={!canEdit}
            />
            <Switch
              name="active"
              label="Use Installer Pay"
              onChange={this.onUseInstallerPayChange}
              theme={crewStyle}
              checked={crew.use_installer_pay}
              disabled={!canEdit}
            />
            <Switch
              name="delivery"
              label="Delivery"
              onChange={this.onDeliveryChange}
              theme={crewStyle}
              checked={crew.can_deliver || false}
              disabled={!canEditBasic}
            />
            <Switch
              name="delivery_dedicated"
              label="Delivery Dedicated"
              onChange={this.onDeliveryDedicatedChange}
              theme={crewStyle}
              checked={crew.delivery_dedicated || false}
              disabled={!canEditBasic}
            />
            <Switch
              name="loginable"
              label="Can Login"
              onChange={this.onLoginableChange}
              theme={crewStyle}
              checked={crew.loginable}
              disabled={!canEditSpecifics}
            />
          </div>
        </FlexBox>
        <br />
      </div>
      <div className={crewStyle.mobileInstallerInfoContainer}>
        <FlexBox>
          <Input
            label="Contact Name"
            value={crew.poc_name}
            className={largeInput}
            error={fieldError('poc_name', crewFieldWarnings)}
            required
            onChange={this.onPOCNameChange}
            disabled={!canEdit}
          />
          <PhoneInput
            label="Phone Number"
            type="tel"
            value={crew.phone_number}
            className={largeInput}
            error={fieldError('phone_number', crewFieldWarnings)}
            onChange={this.onPhoneNumberChange}
            required
            disabled={!canEditSpecifics}
          >
            <PhoneType
              source={PHONE_TYPES_W_FAX}
              value={crew.phone_number_type}
              onChange={this.onPhoneNumberTypeChange}
            />
          </PhoneInput>
          <Input
            label="Email Address"
            value={crew.email}
            className={largeInput}
            error={this.showError('email', errors) || fieldError('email', crewFieldWarnings)}
            onChange={this.onEmailChange}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
      </div>
      <div className={crewStyle.mobileInstallerInfoContainer}>
        <FlexBox>
          <Input
            label="Badge Number"
            value={crew.badge_number}
            className={largeInput}
            error={fieldError('badge_number', crewFieldWarnings)}
            required
            onChange={this.onBadgeNumberChange}
            disabled={!canEdit}
          />
          <DatePicker
            label="Badge expiration"
            className={largeInput}
            value={crew.badge_expiration}
            onChange={this.onBadgeExpirationChange}
            error={fieldError('badge_expiration', crewFieldWarnings)}
            required
            disabled={!canEdit}
          />
          <Input
            label="Badge Link"
            value={crew.badge_link || ''}
            className={largeInput}
            error={this.showError('badge_link', errors)}
            onChange={this.onBadgeLinkChange}
            disabled={!canEdit}
          />
        </FlexBox>
      </div>
      <FlexBox>
        <div>
          <SurfaceTypesCheckbox
            selectedSurfaceTypes={crew.surface_types}
            error={fieldError('surface_types', crewFieldWarnings)}
            onChange={onSurfaceTypesChange}
            required
          />
        </div>
        <div>
          <TimeInput
            label="Default Start Time"
            value={crew.default_start_time}
            onChange={this.onDefaultStartTimeChange}
            errors={errors.default_start_time}
          />
        </div>
      </FlexBox>
      <br />
      <FlexBox>
        <div className={styles.formElementContainer}>
          <ReactSelect
            multi
            name="crewsWorkrooms"
            label="Workrooms"
            required
            className={reactSelectStyles.selectWrapper}
            options={workroomOptions}
            value={crew.workrooms}
            onChange={this.onWorkroomsChange}
            placeholder="Assign workroom(s) to crews"
            error={fieldError('workrooms', crewFieldWarnings)}
          />
        </div>
        <CustomTaggedInput
          label="Assign Zip Code(s) to Crew"
          id="covered_zip_codes"
          crew={crew}
          allWorkrooms={allWorkrooms}
          onCrewZipChange={onChange}
          workroomChange={workroomChange}
          error={fieldError('covered_zip_codes', crewFieldWarnings)}
        />
      </FlexBox>
      {/* Hiding Appt Type Availabilityu for now */}
      {/* <div className={styles.crewSpecsContainer}>
        <h5 className={styles.childTitle}>Appt. Type Availabilities</h5>
      </div>
      <br />
      <FlexBox>
        <div className={crewStyle.crewSwitchContainer}>
          <RadioButtons
            text="Sunday"
            required
            selectedValue={this.getAvailabilityVal(1)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '1_install' },
              { label: 'Delivery', value: '1_delivery' },
              { label: 'Off', value: '1_off' },
            ]}
          />
          <RadioButtons
            text="Monday"
            required
            selectedValue={this.getAvailabilityVal(2)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '2_install' },
              { label: 'Delivery', value: '2_delivery' },
              { label: 'Off', value: '2_off' },
            ]}
          />
          <RadioButtons
            text="Tuesday"
            required
            selectedValue={this.getAvailabilityVal(3)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '3_install' },
              { label: 'Delivery', value: '3_delivery' },
              { label: 'Off', value: '3_off' },
            ]}
          />
          <RadioButtons
            text="Wednesday"
            required
            selectedValue={this.getAvailabilityVal(4)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '4_install' },
              { label: 'Delivery', value: '4_delivery' },
              { label: 'Off', value: '4_off' },
            ]}
          />
          <RadioButtons
            text="Thursday"
            required
            selectedValue={this.getAvailabilityVal(5)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '5_install' },
              { label: 'Delivery', value: '5_delivery' },
              { label: 'Off', value: '5_off' },
            ]}
          />
          <RadioButtons
            text="Friday"
            required
            selectedValue={this.getAvailabilityVal(6)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '6_install' },
              { label: 'Delivery', value: '6_delivery' },
              { label: 'Off', value: '6_off' },
            ]}
          />
          <RadioButtons
            text="Saturday"
            required
            selectedValue={this.getAvailabilityVal(7)}
            onChange={onAvailabilityChange}
            radioButtons={[
              { label: 'Install', value: '7_install' },
              { label: 'Delivery', value: '7_delivery' },
              { label: 'Off', value: '7_off' },
            ]}
          />
        </div>
      </FlexBox> */}
      <div className={styles.crewSpecsContainer}>
        <h5 className={styles.childTitle}>Daily {crew.delivery_dedicated ? 'Delivery' : ''} Availabilities</h5>
      </div>
      <br />
      <FlexBox>
        <ReactSelect
          multi
          name="morningAvailability"
          label={`${crew.delivery_dedicated ? 'Morning' : 'Installation'} Availability`}
          required
          className={reactSelectStyles.selectWrapper}
          options={this.dailyOptions()}
          value={dailyAvailability.morning}
          onChange={val => onDailyChange('morning', val.map(v => v.value))}
          placeholder={`Assign daily ${crew.delivery_dedicated ? 'morning' : ''} availability to crews`}
          error={this.showError('daily_availability', errors)}
        />
        {crew.delivery_dedicated && <ReactSelect
          multi
          name="afternoonAvailability"
          label="Afternoon Availability"
          required
          className={reactSelectStyles.selectWrapper}
          options={this.dailyOptions()}
          value={dailyAvailability.afternoon}
          onChange={val => onDailyChange('afternoon', val.map(v => v.value))}
          placeholder="Assign daily afternoon availability to crews"
          error={this.showError('daily_availability', errors)}
        />}
      </FlexBox>
      <div className={styles.crewSpecsContainer}>
        <h5 className={styles.childTitle}>Crew Specifics</h5>
      </div>
      <br />
      <FlexBox>
        <Input
          label="Max Travel Time (mins)"
          value={crewSpecific.max_travel_time}
          className={mediumInput}
          error={this.showError('max_travel_time', errors)}
          required
          onChange={this.handleMaxTravelTime}
          disabled={!canEditSpecifics}
        />
        <div className={crewStyle.crewActiveSwitch}>
          <Switch
            name="phoneCallNeeded"
            label="Phone Call Needed"
            onChange={this.handlePhoneCallNeeded}
            theme={crewStyle}
            checked={crewSpecific.phone_call_needed}
            disabled={!canEditSpecifics}
          />
        </div>
      </FlexBox>
      <FlexBox>
        <Input
          label="Hardwood SQFT Per Day"
          value={crewSpecific.hardwood_sf_per_day}
          className={mediumInput}
          error={this.showError('hardwood_sf_per_day', errors)}
          required
          onChange={this.handleHardwoodSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Carpet SQFT Per Day"
          value={crewSpecific.carpet_sf_per_day}
          className={mediumInput}
          error={this.showError('carpet_sf_per_day', errors)}
          required
          onChange={this.handleCarpetSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Tile SQFT Per Day"
          value={crewSpecific.tile_sf_per_day}
          className={mediumInput}
          error={this.showError('tile_sf_per_day', errors)}
          required
          onChange={this.handleTileSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Laminate SQFT Per Day"
          value={crewSpecific.laminate_sf_per_day}
          className={mediumInput}
          error={this.showError('laminate_sf_per_day', errors)}
          required
          onChange={this.handleLaminateSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Vinyl SQFT Per Day"
          value={crewSpecific.vinyl_sf_per_day}
          className={mediumInput}
          error={this.showError('vinyl_sf_per_day', errors)}
          required
          onChange={this.handleVinylSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Vinyl Plank SQFT Per Day"
          value={crewSpecific.vinyl_plank_sf_per_day}
          className={mediumInput}
          error={this.showError('vinyl_plank_sf_per_day', errors)}
          required
          onChange={this.handleVinylPlankSfPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Backsplash SQFT Per Day"
          value={crewSpecific.backsplash_sf_per_day}
          className={mediumInput}
          error={this.showError('backsplash_sf_per_day', errors)}
          required
          onChange={this.handleBacksplashSfPerDay}
          disabled={!canEditSpecifics}
        />
        {/* <Input
          label="Millwork Window Per Day"
          value={crewSpecific.millwork_window_per_day}
          className={mediumInput}
          error={this.showError('millwork_window_per_day', errors)}
          required
          onChange={this.handleMillworkWindowPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Millwork Entry Door Per Day"
          value={crewSpecific.millwork_entry_door_per_day}
          className={mediumInput}
          error={this.showError('millwork_entry_door_per_day', errors)}
          required
          onChange={this.handleMillworkEntryDoorPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Millwork Sliding Door Per Day"
          value={crewSpecific.millwork_sliding_door_per_day}
          className={mediumInput}
          error={this.showError('millwork_sliding_door_per_day', errors)}
          required
          onChange={this.handleMillworkSlidingDoorPerDay}
          disabled={!canEditSpecifics}
        />
        <Input
          label="Millwork Interior Door Per Day"
          value={crewSpecific.millwork_interior_door_per_day}
          className={mediumInput}
          error={this.showError('millwork_interior_door_per_day', errors)}
          required
          onChange={this.handleMillworkInteriorDoorPerDay}
          disabled={!canEditSpecifics}
        /> */}
      </FlexBox>
      <div className={crewStyle.crewSwitchContainer}>
        <FlexBox>
          <Switch
            name="speakEnglish"
            label="Speak English"
            onChange={this.handleCanSpeakEnglish}
            theme={crewStyle}
            checked={crewSpecific.can_speak_english}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="speakSpanish"
            label="Speak Spanish"
            onChange={this.handleCanSpeakSpanish}
            theme={crewStyle}
            checked={crewSpecific.can_speak_spanish}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canMoveFurniture"
            label="Move Furniture"
            onChange={this.handleCanMoveFurniture}
            theme={crewStyle}
            checked={crewSpecific.can_move_furniture}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canMoveFurnitureOversized"
            label="Move Oversized Furniture"
            onChange={this.handleCanMoveFurnitureOversized}
            theme={crewStyle}
            checked={crewSpecific.can_move_furniture_oversized}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canMoveAppliances"
            label="Move Appliances"
            onChange={this.handleCanMoveAppliances}
            theme={crewStyle}
            checked={crewSpecific.can_move_appliances}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoSubfloorPrep"
            label="Subfloor Prep"
            onChange={this.handleCanDoSubfloorPrep}
            theme={crewStyle}
            checked={crewSpecific.can_do_subfloor_prep}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoSubfloorReplacement"
            label="Subfloor Replacement"
            onChange={this.handleCanDoSubfloorReplacement}
            theme={crewStyle}
            checked={crewSpecific.can_do_subfloor_replacement}
            disabled={!canEditSpecifics}
          />
          {/* <Switch
            name="sameDayMultiSurface"
            label="Same Day Multi Surface"
            onChange={this.handleSameDayMultiSurface}
            theme={crewStyle}
            checked={crewSpecific.same_day_multi_surface}
            disabled={!canEditSpecifics}
          /> */}
          <Switch
            name="canDoNaildownHardwood"
            label="Naildown Hardwood"
            onChange={this.handleCanDoNaildownHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_do_naildown_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoGluedownHardwood"
            label="Gluedown Hardwood"
            onChange={this.handleCanDoGluedownHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_do_gluedown_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoFloatingHardwood"
            label="Floating Hardwood"
            onChange={this.handleCanDoFloatingHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_do_floating_hardwood}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
        <FlexBox>
          <Switch
            name="canDoCaliBambooHardwood"
            label="Cali Bamboo"
            onChange={this.handleCanDoCaliBambooHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_do_cali_bamboo_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoStepsHardwood"
            label="Hardwood Steps"
            onChange={this.handleCanDoStepsHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_do_steps_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoStretchInCarpet"
            label="Stretch In Carpet"
            onChange={this.handleCanDoStretchInCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_stretch_in_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoGluedownCarpet"
            label="Gluedown Carpet"
            onChange={this.handleCanDoGluedownCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_gluedown_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoBindingCarpet"
            label="Binding Carpet"
            onChange={this.handleCanDoBindingCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_binding_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoPatternMatchCarpet"
            label="Pattern Match Carpet"
            onChange={this.handleCanDoPatternMatchCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_pattern_match_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoBerberCarpet"
            label="Berber Carpet"
            onChange={this.handleCanDoBerberCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_berber_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoStepsCarpet"
            label="Carpet Steps"
            onChange={this.handleCanDoStepsCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_do_steps_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoFloorTile"
            label="Floor Tile"
            onChange={this.handleCanDoFloorTile}
            theme={crewStyle}
            checked={crewSpecific.can_do_floor_tile}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoTilePatterns"
            label="Tile Patterns"
            onChange={this.handleCanDoPatternsTile}
            theme={crewStyle}
            checked={crewSpecific.can_do_patterns_tile}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
        <FlexBox>
          <Switch
            name="canLargeFormatTile"
            label="Large Format Tile"
            onChange={this.handleCanDoLargeFormatTile}
            theme={crewStyle}
            checked={crewSpecific.can_do_large_format_tile}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoBacksplashTile"
            label="Backsplash Tile"
            onChange={this.handleCanDoBacksplashTile}
            theme={crewStyle}
            checked={crewSpecific.can_do_backsplash_tile}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoBacksplashGlass"
            label="Glass Backsplash"
            onChange={this.handleCanDoBacksplashGlass}
            theme={crewStyle}
            checked={crewSpecific.can_do_backsplash_glass}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoBacksplashBlocking"
            label="Backsplash Blocking"
            onChange={this.handleCanDoBacksplashBlocking}
            theme={crewStyle}
            checked={crewSpecific.can_do_backsplash_blocking}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoVinylSheet"
            label="Sheet Vinyl"
            onChange={this.handleCanDoVinylSheet}
            theme={crewStyle}
            checked={crewSpecific.can_do_vinyl_sheet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoVctLvt"
            label="Vinyl Tile"
            onChange={this.handleCanDoVinylTile}
            theme={crewStyle}
            checked={crewSpecific.can_do_vct_lvt}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoGluedownVinylPlank"
            label="Gluedown VP"
            onChange={this.handleCanDoGluedownVinylPlank}
            theme={crewStyle}
            checked={crewSpecific.can_do_gluedown_vinyl_plank}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canDoFloatingVinylPlank"
            label="Floating VP"
            onChange={this.handleCanDoFloatingVinylPlank}
            theme={crewStyle}
            checked={crewSpecific.can_do_floating_vinyl_plank}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveReplaceToilet"
            label="Remove/Replace Toilet"
            onChange={this.handleCanRemoveReplaceToilet}
            theme={crewStyle}
            checked={crewSpecific.can_remove_replace_toilet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveNaildownHardwood"
            label="Remove Naildown Hardwood"
            onChange={this.handleCanRemoveNaildownHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_remove_naildown_hardwood}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
        <FlexBox>
          <Switch
            name="canRemoveFloatingHardwood"
            label="Remove Floating Hardwood"
            onChange={this.handleCanRemoveFloatingHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_remove_floating_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveGluedownHardwood"
            label="Remove Gluedown Hardwood"
            onChange={this.handleCanRemoveGluedownHardwood}
            theme={crewStyle}
            checked={crewSpecific.can_remove_gluedown_hardwood}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveOverPadCarpet"
            label="Remove Carpet Over Pad"
            onChange={this.handleCanRemoveOverPadCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_remove_over_pad_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveGluedownCarpet"
            label="Remove Gluedown Carpet"
            onChange={this.handleCanRemoveGluedownCarpet}
            theme={crewStyle}
            checked={crewSpecific.can_remove_gluedown_carpet}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveLaminate"
            label="Remove Laminate"
            onChange={this.handleCanRemoveLaminate}
            theme={crewStyle}
            checked={crewSpecific.can_remove_laminate}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveTile"
            label="Remove Tile"
            onChange={this.handleCanRemoveTile}
            theme={crewStyle}
            checked={crewSpecific.can_remove_tile}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveGluedownVinyl"
            label="Remove Gluedown Vinyl"
            onChange={this.handleCanRemoveGluedownVinyl}
            theme={crewStyle}
            checked={crewSpecific.can_remove_gluedown_vinyl}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveVinylPlank"
            label="Remove Vinyl Plank"
            onChange={this.handleCanRemoveVinylPlank}
            theme={crewStyle}
            checked={crewSpecific.can_remove_vinyl_plank}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canRemoveBacksplash"
            label="Remove Backsplash"
            onChange={this.handleCanRemoveBacksplash}
            theme={crewStyle}
            checked={crewSpecific.can_remove_backsplash}
            disabled={!canEditSpecifics}
          />
          <Switch
            name="canInstallBaseBoard"
            label="Install Baseboard"
            onChange={this.handleCanInstallBaseBoard}
            theme={crewStyle}
            checked={crewSpecific.can_do_baseboard}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
        <FlexBox>
          <Switch
            name="canInstallHardSurfaceTransitions"
            label="Install Hard Surface Transitions"
            onChange={this.handleCanInstallHardsurfaceTransitions}
            theme={crewStyle}
            checked={crewSpecific.can_install_hard_transitions}
            disabled={!canEditSpecifics}
          />
        </FlexBox>
      </div>
      <br />
      <h5 className={styles.childTitle}>Notes/Comments</h5>
      <Input
        multiline
        theme={styles}
        value={crew.comments || ''}
        className={styles.textArea}
        error={this.showError('comments', errors)}
        required
        onChange={this.onCommentsChange}
      />
      {!shouldShowRemoveButton ? null : (<ColoredButton
        className={removeButton}
        responsive
        color="red"
        label="Remove"
        onClick={this.handleDelete}
      />)}
      <ConflictingAppointmentModal
        active={showApptWarningDialog}
        appts={crew.appointments || []}
        source="crew"
        onClose={() => this.handleApptWarningModal(false)}
      />
    </div>);
  }
}

CrewForm.propTypes = {
  index: PropTypes.number,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  onSpecificChange: PropTypes.func,
  onSurfaceTypesChange: PropTypes.func,
  onAvailabilityChange: PropTypes.func,
  onDailyChange: PropTypes.func,
  errors: PropTypes.object,
  crew: PropTypes.object,
  allWorkrooms: PropTypes.array,
  canRemoveCrew: PropTypes.bool,
  canEdit: PropTypes.bool,
  canEditBasic: PropTypes.bool,
  workroomChange: PropTypes.bool,
  crewFieldWarnings: PropTypes.array,
  fieldError: PropTypes.func,
};

export default CrewForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/crewForm.jsx